import moment from 'moment'

export function formatDate(date: string | null) {
  if (!date) return ''

  return moment(date).format('lll')
}
